import React from 'react'
import {reduxForm} from 'redux-form'

const ControlForm = ({children}) => <>{children}</>

export default /*#__PURE__*/ reduxForm({
  form: 'control-form',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ControlForm)
